import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryTransportInfos(
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/transport-infos`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryTransportInfo(transportInfoId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/transport-infos/${transportInfoId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  locations
 * @param  baseWeight
 * @param  postage
 * @param  unitWeight
 * @param  unitPostage
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addTransportInfo(
  {
    locations,
    baseWeight,
    postage,
    unitWeight,
    unitPostage,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/transport-infos`,
    method: 'post',
    data: {
      locations,
      baseWeight,
      postage,
      unitWeight,
      unitPostage,
    },
  });
}

/**
 * 更新
 * @param transportInfoId
 * @param  locations
 * @param  baseWeight
 * @param  postage
 * @param  unitWeight
 * @param  unitPostage
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateTransportInfo(transportInfoId, {
  locations,
  baseWeight,
  postage,
  unitWeight,
  unitPostage,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/transport-infos/${transportInfoId}`,
    method: 'patch',
    data: {
      locations,
      baseWeight,
      postage,
      unitWeight,
      unitPostage,
    },
  });
}

/**
 * 删除
 * @param transportInfoId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteTransportInfo(transportInfoId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/transport-infos/${transportInfoId}`,
    method: 'delete',
  });
}

export default {};
